import React, { useLayoutEffect, useState } from "react";
import "./App.css";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import TestOurTech_thankyou from "./Components/TestOurTech_thankyou";
import RegisterForm from "./Components/RegisterForm";
import RegisterFormBostonFam from "./Components/RegisterFormBostonFam";
import NotFound from "./Components/NotFound";
import UserformService from "./services/register.service";
import { Helmet } from "react-helmet";
import NotFoundCustom from "./Components/NotFoundCustom";

function App() {
  if (process.env.REACT_APP_STAGE === "PROD")
    console.log = function no_console() {};
  const ToHome = () => {
    return <Redirect to="/" />;
  };

  // checking of redeemption and register
  const [permissions, setPermissions] = useState(null);
  const [permissionsLoading, setPermissionsLoading] = useState(true);

  const LoadingBox = () => {
    return (
      <>
        <div className={`loader in bg-white`}>
          <div className="spinner-border main-spin"></div>
        </div>
      </>
    );
  };

  useLayoutEffect(() => {
    const getSiteDetailsPer = async () => {
      try {
        setPermissionsLoading(true);
        const response = await UserformService.getSitePermissions();

        setPermissions(response?.data?.response || null);
        setPermissionsLoading(false);
      } catch (error) {
        setPermissions(null);
        setPermissionsLoading(false);
      }
    };
    getSiteDetailsPer();
  }, []);
  // checking of redeemption and register end

  return (
    <BrowserRouter>
      <Switch>
        <Route
          exact
          path="/"
          component={
            permissionsLoading
              ? LoadingBox
              : permissions?.register === "yes"
              ? RegisterForm
              : NotFound
          }
        />
        <Route
          exact
          path="/bostonfam"
          component={
            permissionsLoading
              ? LoadingBox
              : permissions?.register === "yes"
              ? RegisterFormBostonFam
              : NotFoundCustom
          }
        />
        <Route
          exact
          path="/morris"
          component={
            permissionsLoading
              ? LoadingBox
              : permissions?.register === "yes"
              ? RegisterForm
              : NotFound
          }
        />
        <Route
          exact
          path="/TestOurTech_thankyou"
          component={
            permissionsLoading
              ? LoadingBox
              : permissions?.register === "yes"
              ? TestOurTech_thankyou
              : NotFound
          }
        />

        <Route exact path="*" component={NotFound} />
      </Switch>
    </BrowserRouter>
  );
}

export default App;
